import dimensionsModule from 'src/utils/styles/_dimensions.module.scss';

const dimensions = dimensionsModule.locals;

export const buttonAnimationVariants = {
  fullWidth: {
    width: window.innerWidth < dimensions.mobileBreakpoint ? 290 : 310,
    height: window.innerWidth < dimensions.mobileBreakpoint ? 42 : 46,
    transition: {
      delayChildren: 0.1,
    },
  },
  collapsed: {
    width: 45,
    height: 45,
  },
};

export const contentHolderAnimationVariants = {
  fullWidth: { opacity: 1, transition: { duration: 0.2 } },
  collapsed: { opacity: 0, transition: { duration: 0 } },
};
